<template>
    <div class="site-wrapper no-header">
        <div class="container">
            <div v-if="isAdmin">
                <div class="notification is-primary"><h3>All Action Tags</h3></div>

                <!-- <div v-if="isSteve" class="buttons">
            <span class="button is-danger" @click="deleteAllTags()">Delete All Tags</span>
          </div> -->

                <div class="tag-wrapper has-text-centered">
                    <div class="tags has-addons has-text-centered">
                        <span class="tag is-danger is-medium"><font-awesome-icon icon="stopwatch"/></span>
                        <span class="tag is-success is-medium">{{ timeNow }}</span>
                    </div>
                </div>
                <div class="spacer s20"></div>

                <!-- <ul>
            <li>a1: {{a1}}</li>
            <li>a2: {{a2}}</li>
            <li>a3: {{a3}}</li>
            <li>b1: {{b1}}</li>
            <li>b2: {{b2}}</li>
            <li>b3: {{b3}}</li>
            <li>b4: {{b4}}</li>
            <li>b5: {{b5}}</li>
            <li>b6: {{b6}}</li>
            <li>b7: {{b7}}</li>
            <li>b8: {{b8}}</li>
            <li>b9: {{b9}}</li>
          </ul>

          <hr>

          <ul>
            <li v-for="result in sorted(results)" :key="result.tag">{{result}}</li>
          </ul> -->

                <table class="table">
                    <tr>
                        <th>Tag</th>
                        <th>Count</th>
                    </tr>
                    <tr v-for="result in sorted(results)" :key="result.tag">
                        <td :style="{ color: result.color }">
                            <span class="caps bold">{{ result.tag }}</span
                            >: {{ result.title }}
                        </td>
                        <td>{{ result.index }}</td>
                    </tr>
                </table>

                <!-- {{results}} -->

                <div v-if="actionTags.length">
                    <ul class="listed">
                        <!-- <li v-for="(item, index) in actionTags" :key="index">{{item.timestamp}}: {{item.tag}}</li> -->
                        <li v-for="(item, index) in actionTags" :key="index" :style="{ color: tagColors[item.tag] }">
                            {{ item.timestamp }}: {{ tags[item.tag] }}
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else>This page is restricted.</div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { db } from '../main.js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import * as moment from 'moment';

export default {
    name: 'Demo',

    data: function() {
        return {
            firebaseid: '',
            firebaseemail: '',
            firebasedisplayname: '',
            actionTags: [],
            timeNow: 'no time',

            tags: {
                a1: 'View app features',
                a2: 'Create a profile',
                a3: 'Login as a user',
                b1: 'View help center options',
                b2: 'View all vessels',
                b3: 'View user profile',
                b4: 'View personal timers (inc sea time)',
                b5: 'Access my notes and todo list',
                b6: 'Open QR code scanner',
                b7: 'Access favourites buttons',
                b8: 'View personal messages',
                b9: 'Open top right slide menu',
                c1: 'View my own vessels',
                c2: 'View vessels I work on',
                d1: 'Refresh vessels on pull down',
                d2: 'Search for a vessel to request crew access',
                e1: 'Refresh vessels on pull down',
                e2: 'Add my own free vessel',
                s1: 'Show QR modal',
                s2: 'Generate new vessel QR code',
                s3: 'View vessel QR code info page',
                s4: 'Show location pin modal',
                s5: 'Save new location',
                s6: 'View subscription / upgrade options',
                s7: 'View all vessel logs screen',
                s8: 'View vessel information',
                s9: 'View subscription / upgrade options',
                s10: 'View all vessel alerts',
                s11: 'View vessel equipment and inventory',
                s12: 'View the vessel SMS',
                s13: 'View the vessel operations manual',
                s14: 'View all vessel crew',
                s15: 'View self inductions screen',
                s16: 'Delete or remove a vessel',
                p1: 'Manage subscription for this vessel',
                p2: 'View Ships Log',
                p3: 'New startup log',
                p4: 'New quick maintenance log',
                p5: 'New incident log',
                p6: 'View past visitor check-ins',
                p7: 'New general safety briefing log',
                p8: 'New crew induction',
                p9: 'View all past trips',
                p10: 'View all vessel defects',
                p11: 'New fluids and engine hours log',
                p12: 'View plant and equipment',
                p13: 'View all schedules and drills',
                p14: 'View all timed activities',
                p15: 'New JSA log',
                p16: 'New mid trip activity log',
                p17: 'New shutdown log',
                p18: 'View passenger manifests',
                p19: 'New passenger safety briefing log',
                p20: 'New head couont log',

                n1: 'View the new public vessel profile page',
                n2: 'View past maintenance',
                n3: 'View my shortcuts',
                n4: 'Shared SMS tokens screen',
                n5: 'Share SMS suggestions',
                n6: 'General settings in app',
                n7: 'Key vessel information',
                n8: 'Vessel spec sheet',
                n9: 'Manage crew from vessel info landing page',
                n10: 'Activity timeline from info landing page',
                n11: 'All expense logs',
                n12: 'View manage trips page',
                n13: 'View active trip',
                n14: 'View all scheduled trips',
                n15: 'Full startup log from Manage Trips (3 options)',
                n16: 'Start an instant trip (3 options)',
                n17: 'Crew & Passengers page',
                n18: 'My Self Inductions page',
                n19: 'New all crew page',
                n20: 'Start a crew induction',
                n21: 'Start a new drill schedule',
                n22: 'New incident report',
                n23: 'New safety briefing',
                n24: 'Open Log Sequences modal',
                n25: 'View SMS',
                n26: 'View new P&E page',
                n27: 'View new inventry landing page',
                n28: 'View all past logs',
                n29: 'Ops manual landing',
                n30: 'Schedule a new trip',
                n31: 'New trip saved / scheduled',
                n32: 'Log an Activity modal opened',
                n33: 'Add to the timeline button pressed',
                n34: 'New timeline entry saved',
                n35: 'View app user guides',
                n36: 'App support page',
                n37: 'View app reviews',
                n38: 'Show quick note modal',
                n39: 'Quick note logged immediately',
                n40: 'Quick note saved for later',
                n41: 'My marine fleets page',
                n42: 'View my workflows page',
                n43: 'My App Tools page',
                n44: 'View my personal timers',
                n45: 'Original seatime logs page',
                n46: 'My notes and todo lists',
                n47: 'View dashboard settings page'
            },
            tagColors: {
                a1: 'red',
                a2: 'cadetblue',
                a3: 'grey',
                b1: 'orange',
                b2: 'mediumseagreen',
                b3: 'dodgerblue',
                b4: 'brown',
                b5: 'orangered',
                b6: 'skyblue',
                b7: 'sandybrown',
                b8: 'lightseagreen',
                b9: 'purple',

                c1: 'red',
                c2: 'cadetblue',
                d1: 'grey',
                d2: 'mediumseagreen',
                e1: 'dodgerblue',
                e2: 'cadetblue',
                s1: 'grey',
                s2: 'red',
                s3: 'brown',
                s4: 'orangered',
                s5: 'dodgerblue',
                s6: 'cadetblue',
                s7: 'lightseagreen',
                s8: 'purple',
                s9: 'red',
                s10: 'sandybrown',
                s11: 'dodgerblue',
                s12: 'grey',
                s13: 'brown',
                s14: 'dodgerblue',
                s15: 'orangered',
                s16: 'red',
                p1: 'mediumseagreen',
                p2: 'purple',
                p3: 'cadetblue',
                p4: 'dodgerblue',
                p5: 'purple',
                p6: 'grey',
                p7: 'red',
                p8: 'sandybrown',
                p9: 'brown',
                p10: 'lightseagreen',
                p11: 'dodgerblue',
                p12: 'mediumseagreen',
                p13: 'red',
                p14: 'brown',
                p15: 'orangered',
                p16: 'purple',
                p17: 'sandybrown',
                p18: 'dodgerblue',
                p19: 'lightseagreen',
                p20: 'red'
            }
        };
    },

    watch: {
        firebaseid: function() {
            this.isSteve = this.firebaseid == 'M3GGz7qWIxNqAsN2Ojglrv334jm1' || this.firebaseid == '3wTzZecD4QYOPUk4IyWRA2JmDcJ2' ? true : false;
        }
    },

    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        userData() {
            return this.$store.getters.getSubscriptionInfo;
        },
        isAdmin() {
            return this.$store.getters.getIsAdmin;
        },
        a1() {
            return this.actionTags.filter(tag => tag.tag == 'a1').length;
        },
        a2() {
            return this.actionTags.filter(tag => tag.tag == 'a2').length;
        },
        a3() {
            return this.actionTags.filter(tag => tag.tag == 'a3').length;
        },
        b1() {
            return this.actionTags.filter(tag => tag.tag == 'b1').length;
        },
        b2() {
            return this.actionTags.filter(tag => tag.tag == 'b2').length;
        },
        b3() {
            return this.actionTags.filter(tag => tag.tag == 'b3').length;
        },
        b4() {
            return this.actionTags.filter(tag => tag.tag == 'b4').length;
        },
        b5() {
            return this.actionTags.filter(tag => tag.tag == 'b5').length;
        },
        b6() {
            return this.actionTags.filter(tag => tag.tag == 'b6').length;
        },
        b7() {
            return this.actionTags.filter(tag => tag.tag == 'b7').length;
        },
        b8() {
            return this.actionTags.filter(tag => tag.tag == 'b8').length;
        },
        b9() {
            return this.actionTags.filter(tag => tag.tag == 'b9').length;
        },

        c1() {
            return this.actionTags.filter(tag => tag.tag == 'c1').length;
        },
        c2() {
            return this.actionTags.filter(tag => tag.tag == 'c2').length;
        },
        c3() {
            return this.actionTags.filter(tag => tag.tag == 'c3').length;
        },
        d1() {
            return this.actionTags.filter(tag => tag.tag == 'd1').length;
        },
        d2() {
            return this.actionTags.filter(tag => tag.tag == 'd2').length;
        },
        e1() {
            return this.actionTags.filter(tag => tag.tag == 'e1').length;
        },
        e2() {
            return this.actionTags.filter(tag => tag.tag == 'e2').length;
        },

        s1() {
            return this.actionTags.filter(tag => tag.tag == 's1').length;
        },
        s2() {
            return this.actionTags.filter(tag => tag.tag == 's2').length;
        },
        s3() {
            return this.actionTags.filter(tag => tag.tag == 's3').length;
        },
        s4() {
            return this.actionTags.filter(tag => tag.tag == 's4').length;
        },
        s5() {
            return this.actionTags.filter(tag => tag.tag == 's5').length;
        },
        s6() {
            return this.actionTags.filter(tag => tag.tag == 's6').length;
        },
        s7() {
            return this.actionTags.filter(tag => tag.tag == 's7').length;
        },
        s8() {
            return this.actionTags.filter(tag => tag.tag == 's8').length;
        },
        s9() {
            return this.actionTags.filter(tag => tag.tag == 's9').length;
        },
        s10() {
            return this.actionTags.filter(tag => tag.tag == 's10').length;
        },
        s11() {
            return this.actionTags.filter(tag => tag.tag == 's11').length;
        },
        s12() {
            return this.actionTags.filter(tag => tag.tag == 's12').length;
        },
        s13() {
            return this.actionTags.filter(tag => tag.tag == 's13').length;
        },
        s14() {
            return this.actionTags.filter(tag => tag.tag == 's14').length;
        },
        s15() {
            return this.actionTags.filter(tag => tag.tag == 's15').length;
        },
        s16() {
            return this.actionTags.filter(tag => tag.tag == 's16').length;
        },

        p1() {
            return this.actionTags.filter(tag => tag.tag == 'p1').length;
        },
        p2() {
            return this.actionTags.filter(tag => tag.tag == 'p2').length;
        },
        p3() {
            return this.actionTags.filter(tag => tag.tag == 'p3').length;
        },
        p4() {
            return this.actionTags.filter(tag => tag.tag == 'p4').length;
        },
        p5() {
            return this.actionTags.filter(tag => tag.tag == 'p5').length;
        },
        p6() {
            return this.actionTags.filter(tag => tag.tag == 'p6').length;
        },
        p7() {
            return this.actionTags.filter(tag => tag.tag == 'p7').length;
        },
        p8() {
            return this.actionTags.filter(tag => tag.tag == 'p8').length;
        },
        p9() {
            return this.actionTags.filter(tag => tag.tag == 'p9').length;
        },
        p10() {
            return this.actionTags.filter(tag => tag.tag == 'p10').length;
        },
        p11() {
            return this.actionTags.filter(tag => tag.tag == 'p11').length;
        },
        p12() {
            return this.actionTags.filter(tag => tag.tag == 'p12').length;
        },
        p13() {
            return this.actionTags.filter(tag => tag.tag == 'p13').length;
        },
        p14() {
            return this.actionTags.filter(tag => tag.tag == 'p14').length;
        },
        p15() {
            return this.actionTags.filter(tag => tag.tag == 'p15').length;
        },
        p16() {
            return this.actionTags.filter(tag => tag.tag == 'p16').length;
        },
        p17() {
            return this.actionTags.filter(tag => tag.tag == 'p17').length;
        },
        p18() {
            return this.actionTags.filter(tag => tag.tag == 'p18').length;
        },
        p19() {
            return this.actionTags.filter(tag => tag.tag == 'p19').length;
        },
        p20() {
            return this.actionTags.filter(tag => tag.tag == 'p20').length;
        },

        n1() {
            return this.actionTags.filter(tag => tag.tag == 'n1').length;
        },
        n2() {
            return this.actionTags.filter(tag => tag.tag == 'n2').length;
        },
        n3() {
            return this.actionTags.filter(tag => tag.tag == 'n3').length;
        },
        n4() {
            return this.actionTags.filter(tag => tag.tag == 'n4').length;
        },
        n5() {
            return this.actionTags.filter(tag => tag.tag == 'n5').length;
        },
        n6() {
            return this.actionTags.filter(tag => tag.tag == 'n6').length;
        },
        n7() {
            return this.actionTags.filter(tag => tag.tag == 'n7').length;
        },
        n8() {
            return this.actionTags.filter(tag => tag.tag == 'n8').length;
        },
        n9() {
            return this.actionTags.filter(tag => tag.tag == 'n9').length;
        },
        n10() {
            return this.actionTags.filter(tag => tag.tag == 'n10').length;
        },
        n11() {
            return this.actionTags.filter(tag => tag.tag == 'n11').length;
        },
        n12() {
            return this.actionTags.filter(tag => tag.tag == 'n12').length;
        },
        n13() {
            return this.actionTags.filter(tag => tag.tag == 'n13').length;
        },
        n14() {
            return this.actionTags.filter(tag => tag.tag == 'n14').length;
        },
        n15() {
            return this.actionTags.filter(tag => tag.tag == 'n15').length;
        },
        n16() {
            return this.actionTags.filter(tag => tag.tag == 'n16').length;
        },
        n17() {
            return this.actionTags.filter(tag => tag.tag == 'n17').length;
        },
        n18() {
            return this.actionTags.filter(tag => tag.tag == 'n18').length;
        },
        n19() {
            return this.actionTags.filter(tag => tag.tag == 'n19').length;
        },
        n20() {
            return this.actionTags.filter(tag => tag.tag == 'n20').length;
        },
        n21() {
            return this.actionTags.filter(tag => tag.tag == 'n21').length;
        },
        n22() {
            return this.actionTags.filter(tag => tag.tag == 'n22').length;
        },
        n23() {
            return this.actionTags.filter(tag => tag.tag == 'n23').length;
        },
        n24() {
            return this.actionTags.filter(tag => tag.tag == 'n24').length;
        },
        n25() {
            return this.actionTags.filter(tag => tag.tag == 'n25').length;
        },
        n26() {
            return this.actionTags.filter(tag => tag.tag == 'n26').length;
        },
        n27() {
            return this.actionTags.filter(tag => tag.tag == 'n27').length;
        },
        n28() {
            return this.actionTags.filter(tag => tag.tag == 'n28').length;
        },
        n29() {
            return this.actionTags.filter(tag => tag.tag == 'n29').length;
        },
        n30() {
            return this.actionTags.filter(tag => tag.tag == 'n30').length;
        },
        n31() {
            return this.actionTags.filter(tag => tag.tag == 'n31').length;
        },
        n32() {
            return this.actionTags.filter(tag => tag.tag == 'n32').length;
        },
        n33() {
            return this.actionTags.filter(tag => tag.tag == 'n33').length;
        },
        n34() {
            return this.actionTags.filter(tag => tag.tag == 'n34').length;
        },
        n35() {
            return this.actionTags.filter(tag => tag.tag == 'n35').length;
        },
        n36() {
            return this.actionTags.filter(tag => tag.tag == 'n36').length;
        },
        n37() {
            return this.actionTags.filter(tag => tag.tag == 'n37').length;
        },
        n38() {
            return this.actionTags.filter(tag => tag.tag == 'n38').length;
        },
        n39() {
            return this.actionTags.filter(tag => tag.tag == 'n39').length;
        },
        n40() {
            return this.actionTags.filter(tag => tag.tag == 'n40').length;
        },
        n41() {
            return this.actionTags.filter(tag => tag.tag == 'n41').length;
        },
        n42() {
            return this.actionTags.filter(tag => tag.tag == 'n42').length;
        },
        n43() {
            return this.actionTags.filter(tag => tag.tag == 'n43').length;
        },
        n44() {
            return this.actionTags.filter(tag => tag.tag == 'n44').length;
        },
        n45() {
            return this.actionTags.filter(tag => tag.tag == 'n45').length;
        },
        n46() {
            return this.actionTags.filter(tag => tag.tag == 'n46').length;
        },
        n47() {
            return this.actionTags.filter(tag => tag.tag == 'n47').length;
        },

        results() {
            return [
                { tag: 'a1', title: this.tags['a1'], index: this.a1, color: 'red' },
                { tag: 'a2', title: this.tags['a2'], index: this.a2, color: 'cadetblue' },
                { tag: 'a3', title: this.tags['a3'], index: this.a3, color: 'grey' },
                { tag: 'b1', title: this.tags['b1'], index: this.b1, color: 'orange' },
                { tag: 'b2', title: this.tags['b2'], index: this.b2, color: 'mediumseagreen' },
                { tag: 'b3', title: this.tags['b3'], index: this.b3, color: 'dodgerblue' },
                { tag: 'b4', title: this.tags['b4'], index: this.b4, color: 'brown' },
                { tag: 'b5', title: this.tags['b5'], index: this.b5, color: 'orangered' },
                { tag: 'b6', title: this.tags['b6'], index: this.b6, color: 'skyblue' },
                { tag: 'b7', title: this.tags['b7'], index: this.b7, color: 'sandybrown' },
                { tag: 'b8', title: this.tags['b8'], index: this.b8, color: 'lightseagreen' },
                { tag: 'b9', title: this.tags['b9'], index: this.b9, color: 'purple' },

                { tag: 'c1', title: this.tags['c1'], index: this.c1, color: 'grey' },
                { tag: 'c2', title: this.tags['c2'], index: this.c2, color: 'grey' },
                { tag: 'c3', title: this.tags['c3'], index: this.c3, color: 'grey' },
                { tag: 'd1', title: this.tags['d1'], index: this.d1, color: 'grey' },
                { tag: 'd2', title: this.tags['d2'], index: this.d2, color: 'grey' },
                { tag: 'e1', title: this.tags['e1'], index: this.e1, color: 'grey' },
                { tag: 'e2', title: this.tags['e2'], index: this.e2, color: 'grey' },

                { tag: 's1', title: this.tags['s1'], index: this.s1, color: 'grey' },
                { tag: 's2', title: this.tags['s2'], index: this.s2, color: 'grey' },
                { tag: 's3', title: this.tags['s3'], index: this.s3, color: 'grey' },
                { tag: 's4', title: this.tags['s4'], index: this.s4, color: 'grey' },
                { tag: 's5', title: this.tags['s5'], index: this.s5, color: 'grey' },
                { tag: 's6', title: this.tags['s6'], index: this.s6, color: 'grey' },
                { tag: 's7', title: this.tags['s7'], index: this.s7, color: 'grey' },
                { tag: 's8', title: this.tags['s8'], index: this.s8, color: 'grey' },
                { tag: 's9', title: this.tags['s9'], index: this.s9, color: 'grey' },
                { tag: 's10', title: this.tags['s10'], index: this.s10, color: 'grey' },
                { tag: 's11', title: this.tags['s11'], index: this.s11, color: 'grey' },
                { tag: 's12', title: this.tags['s12'], index: this.s12, color: 'grey' },
                { tag: 's13', title: this.tags['s13'], index: this.s13, color: 'grey' },
                { tag: 's14', title: this.tags['s14'], index: this.s14, color: 'grey' },
                { tag: 's15', title: this.tags['s15'], index: this.s15, color: 'grey' },
                { tag: 's16', title: this.tags['s16'], index: this.s16, color: 'grey' },

                { tag: 'p1', title: this.tags['p1'], index: this.p1, color: 'grey' },
                { tag: 'p2', title: this.tags['p2'], index: this.p2, color: 'grey' },
                { tag: 'p3', title: this.tags['p3'], index: this.p3, color: 'grey' },
                { tag: 'p4', title: this.tags['p4'], index: this.p4, color: 'grey' },
                { tag: 'p5', title: this.tags['p5'], index: this.p5, color: 'grey' },
                { tag: 'p6', title: this.tags['p6'], index: this.p6, color: 'grey' },
                { tag: 'p7', title: this.tags['p7'], index: this.p7, color: 'grey' },
                { tag: 'p8', title: this.tags['p8'], index: this.p8, color: 'grey' },
                { tag: 'p9', title: this.tags['p9'], index: this.p9, color: 'grey' },
                { tag: 'p10', title: this.tags['p10'], index: this.p10, color: 'grey' },
                { tag: 'p11', title: this.tags['p11'], index: this.p11, color: 'grey' },
                { tag: 'p12', title: this.tags['p12'], index: this.p12, color: 'grey' },
                { tag: 'p13', title: this.tags['p13'], index: this.p13, color: 'grey' },
                { tag: 'p14', title: this.tags['p14'], index: this.p14, color: 'grey' },
                { tag: 'p15', title: this.tags['p15'], index: this.p15, color: 'grey' },
                { tag: 'p16', title: this.tags['p16'], index: this.p16, color: 'grey' },
                { tag: 'p17', title: this.tags['p17'], index: this.p17, color: 'grey' },
                { tag: 'p18', title: this.tags['p18'], index: this.p18, color: 'grey' },
                { tag: 'p19', title: this.tags['p19'], index: this.p19, color: 'grey' },
                { tag: 'p20', title: this.tags['p20'], index: this.p20, color: 'grey' },

                { tag: 'n1', title: this.tags['n1'], index: this.n1, color: 'rosybrown' },
                { tag: 'n2', title: this.tags['n2'], index: this.n2, color: 'peach' },
                { tag: 'n3', title: this.tags['n3'], index: this.n3, color: 'orchid' },
                { tag: 'n4', title: this.tags['n4'], index: this.n4, color: 'peru' },
                { tag: 'n5', title: this.tags['n5'], index: this.n5, color: 'cyan' },
                { tag: 'n6', title: this.tags['n6'], index: this.n6, color: 'tan' },
                { tag: 'n7', title: this.tags['n7'], index: this.n7, color: 'steelblue' },
                { tag: 'n8', title: this.tags['n8'], index: this.n8, color: 'salmon' },
                { tag: 'n9', title: this.tags['n9'], index: this.n9, color: 'olive' },
                { tag: 'n10', title: this.tags['n10'], index: this.n10, color: 'beige' },
                { tag: 'n11', title: this.tags['n11'], index: this.n11, color: 'silver' },
                { tag: 'n12', title: this.tags['n12'], index: this.n12, color: 'plum' },
                { tag: 'n13', title: this.tags['n13'], index: this.n13, color: 'powderblue' },
                { tag: 'n14', title: this.tags['n14'], index: this.n14, color: 'springgreen' },
                { tag: 'n15', title: this.tags['n15'], index: this.n15, color: 'tomato' },
                { tag: 'n16', title: this.tags['n16'], index: this.n16, color: 'navy' },
                { tag: 'n17', title: this.tags['n17'], index: this.n17, color: 'palegreen' },
                { tag: 'n18', title: this.tags['n18'], index: this.n18, color: 'lime' },
                { tag: 'n19', title: this.tags['n19'], index: this.n19, color: 'skyblue' },
                { tag: 'n20', title: this.tags['n20'], index: this.n20, color: 'violetred' },
                { tag: 'n21', title: this.tags['n21'], index: this.n21, color: 'lavender' },
                { tag: 'n22', title: this.tags['n22'], index: this.n22, color: 'wheat' },
                { tag: 'n23', title: this.tags['n23'], index: this.n23, color: 'blue' },
                { tag: 'n24', title: this.tags['n24'], index: this.n24, color: 'gold' },
                { tag: 'n25', title: this.tags['n25'], index: this.n25, color: 'magenta' },
                { tag: 'n26', title: this.tags['n26'], index: this.n26, color: 'brown' },
                { tag: 'n27', title: this.tags['n27'], index: this.n27, color: 'teal' },
                { tag: 'n28', title: this.tags['n28'], index: this.n28, color: 'yellow' },
                { tag: 'n29', title: this.tags['n29'], index: this.n29, color: 'green' },
                { tag: 'n30', title: this.tags['n30'], index: this.n30, color: 'coral' },
                { tag: 'n31', title: this.tags['n31'], index: this.n31, color: 'slateblue' },
                { tag: 'n32', title: this.tags['n32'], index: this.n32, color: 'red' },
                { tag: 'n33', title: this.tags['n33'], index: this.n33, color: 'seashell' },
                { tag: 'n34', title: this.tags['n34'], index: this.n34, color: 'maroon' },
                { tag: 'n35', title: this.tags['n35'], index: this.n35, color: 'gray' },
                { tag: 'n36', title: this.tags['n36'], index: this.n36, color: 'indigo' },
                { tag: 'n37', title: this.tags['n37'], index: this.n37, color: 'violet' },
                { tag: 'n38', title: this.tags['n38'], index: this.n38, color: 'pink' },
                { tag: 'n39', title: this.tags['n39'], index: this.n39, color: 'orange' },
                { tag: 'n40', title: this.tags['n40'], index: this.n40, color: 'turquoise' },
                { tag: 'n41', title: this.tags['n41'], index: this.n41, color: 'khaki' },
                { tag: 'n42', title: this.tags['n42'], index: this.n42, color: 'sienna' },
                { tag: 'n43', title: this.tags['n43'], index: this.n43, color: 'purple' },
                { tag: 'n44', title: this.tags['n44'], index: this.n44, color: 'paleturquoise' },
                { tag: 'n45', title: this.tags['n45'], index: this.n45, color: 'royalblue' },
                { tag: 'n46', title: this.tags['n46'], index: this.n46, color: 'seagreen' },
                { tag: 'n47', title: this.tags['n47'], index: this.n47, color: 'thistle' }
            ];
        }
    },

    mounted() {
        this.$store.dispatch('setUser');
        this.$store.dispatch('SETSUBSCRIPTIONINFO');
        firebase.auth().onAuthStateChanged(this.onUserLogin);
        this.timeNow = moment().format('D MMMM YYYY (h:mm a)');
    },

    methods: {
        onUserLogin: function(user) {
            if (user) {
                this.firebaseemail = user.email;
                this.firebaseid = user.uid;
                this.firebasedisplayname = this.userData.username;
                this.loadActionTags();
            }
        },

        trimmed(array) {
            return array.slice(0, 5);
        },

        sorted: function(arr) {
            // Set slice() to avoid to generate an infinite loop!
            return arr.slice().sort(function(a, b) {
                // return a.index - b.index;
                return b.index - a.index;
            });
        },

        loadActionTags: function() {
            let self = this;
            db.collection('actionTags')
                .orderBy('timestamp', 'desc')
                .limit(5000)
                .onSnapshot(function(querySnapshot) {
                    // db.collection('actionTags').limit(500).onSnapshot(function(querySnapshot) {
                    self.actionTags = [];
                    querySnapshot.forEach(function(doc) {
                        // self.actionTags.push(doc.data())
                        self.actionTags.push({
                            id: doc.id,
                            // timestamp: doc.data().timestamp ? doc.data().timestamp.toDate() : '',
                            timestamp: moment(doc.data().timestamp.toDate()).fromNow(),
                            tag: doc.data().tag ? doc.data().tag : '',
                            userid: doc.data().userid ? doc.data().userid : '',
                            os: doc.data().os ? doc.data().os : '',
                            platform: doc.data().platform ? doc.data().platform : ''
                        });
                    });
                });
        },

        deleteAllTags() {
            this.actionTags.forEach(tag => {
                db.collection('actionTags')
                    .doc(tag.id)
                    .delete();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
ul.listed {
    margin-left: 8px;
    margin-bottom: 10px;
}
</style>
